import React, { useEffect, useState } from "react";
import { Hammer, X, ArrowRight } from "lucide-react";
import { TINGTOWN_URL } from "@/config/pricing";

const DISMISS_KEY = "creditcost_buildhelp_dismissed";

// Cross-advertising popup — promotes the T.I.N.G Town "we build apps" service.
// Non-intrusive: slides up once after a short delay, dismissible, remembered.
export function BuildHelpPopup({ blocked = false }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(DISMISS_KEY) === "1") return;
    const t = setTimeout(() => setShow(true), 3500);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    setShow(false);
    localStorage.setItem(DISMISS_KEY, "1");
  };

  if (!show || blocked) return null;

  return (
    <div
      data-testid="build-help-popup"
      className="fixed inset-x-3 bottom-3 z-50 mx-auto max-w-md animate-fade-up sm:inset-x-auto sm:right-5 sm:bottom-5 sm:mx-0 sm:w-96"
    >
      <div className="glass overflow-hidden rounded-2xl border border-border-strong shadow-2xl">
        <div className="flex items-start gap-3 p-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-tint">
            <Hammer size={20} className="text-brand" />
          </div>
          <div className="min-w-0 flex-1">
            <p className="font-display font-bold leading-tight">Want an app like this built?</p>
            <p className="mt-1 text-sm leading-snug text-muted-foreground">
              The T.I.N.G Town Developer District ships custom tools like CreditCost — for you.
            </p>
          </div>
          <button
            data-testid="build-help-close"
            onClick={dismiss}
            className="shrink-0 rounded-md p-1 text-muted-foreground transition-colors hover:text-foreground"
            aria-label="Dismiss"
          >
            <X size={18} />
          </button>
        </div>
        <a
          data-testid="build-help-cta"
          href={TINGTOWN_URL}
          target="_blank"
          rel="noreferrer"
          onClick={dismiss}
          className="flex items-center justify-center gap-1.5 bg-brand py-3 font-display font-bold text-white transition-colors hover:bg-brand-dark"
        >
          Explore the Developer District <ArrowRight size={16} />
        </a>
      </div>
    </div>
  );
}
